import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbDateStruct, NgbInputDatepicker, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators, AbstractControl } from '@angular/forms';
import { LedgerArray, ListWorkshopJobTypes, ResourceList } from '@pos-app/data';
import { MatSort } from '@angular/material/sort';
import { ApiService, AttachmentEntityType, EventService } from '@pos-app/core-ui';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject, BehaviorSubject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { MontlyDateArray } from '../../orders/+state/orders.models';
import moment from 'moment';

@Component({
    selector: 'app-orderDetailCard',
    styleUrls: ['./orderDetailCard.component.scss'],
    templateUrl: './orderDetailCard.component.html',
    standalone: false
})
export class NgbdModalOrderDetailCard implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('focus', { static: false }) resourceDesc1: ElementRef;
  @ViewChild('content') modalBox: any;
  @ViewChild('d') d2: NgbInputDatepicker;

  unSubscribe$ = new Subject<void>();
  @Input() resourceList: Array<ResourceList>;
  @Input() defaultBranch: string;
  @Input() currentDate: string;
  @Input() actionOrderDetailCard: boolean;
  @Input() currentEventData: any;
  @Input() jobTypeList: ListWorkshopJobTypes;
  @Output() loadAllAttachments = new EventEmitter<void>();
  @Input() brandDefaultsPhoneDigits: number;
  @Input() allocated: boolean;

  orderDetailCardForm: UntypedFormGroup;
  overriddenHoursTF: boolean = false;

  resourceSettings: IDropdownSettings = {};
  otherResourceSettings: IDropdownSettings = {};
  technicianResourceList = [];
  selectedResourceList = [];
  selectedOtherResourceList = [];
  otherResourceList = [];
  allAttachments: any;
  viewDetailIndex: any;
  orderLines: any;
  notesCardView: boolean = false;
  scheduleHistoryView: boolean = false;
  isFormValid: boolean = false;
  defaultCompanyCode: string = JSON.parse(localStorage.getItem('jdeSession')).CompanyCode;
  ledgerResultArray: Array<LedgerArray>;
  loading = new BehaviorSubject<boolean>(false);
  currentMonth: number;
  dayDetails: Array<MontlyDateArray> = [];
  fitDays: number;
  fitHours: number;
  previousDateForCalander: string;
  entityId: string;
  entityType: AttachmentEntityType;
  orderDetails: any;
  madeChanges: any;
  addEditNoteView: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private eventService: EventService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private apiService: ApiService,
    private renderer: Renderer2,
  ) {}

  ngOnInit() {
    //get filtered resource list and other resource list

    this.technicianResourceList = this.resourceList?.filter((el) => el.genericResourceTF !== true);
    this.otherResourceList = this.resourceList?.filter((el) => el.genericResourceTF === true);
    const resourceListSet = new Set(this.currentEventData?.ResourceAssigned?.map((item) => item.ResourceID));

    this.selectedResourceList = this.technicianResourceList?.filter((item) => resourceListSet.has(item.resourceID));
    this.selectedOtherResourceList = this.otherResourceList?.filter((item) => resourceListSet.has(item.resourceID));
    //get selected resource list and get selected other resource list
    this.resourceSettings = {
      singleSelection: false,
      idField: 'resourceID',
      textField: 'resourceName',
      enableCheckAll: false,
      noDataAvailablePlaceholderText: 'No Resource Found',
      allowSearchFilter: true,
      clearSearchFilter: true,
      maxHeight: 100,
      // itemsShowLimit: 3,
      searchPlaceholderText: 'Search Technician',
      closeDropDownOnSelection: false,
    };
    this.otherResourceSettings = {
      singleSelection: false,
      idField: 'resourceID',
      textField: 'resourceName',
      enableCheckAll: false,
      noDataAvailablePlaceholderText: 'No Other Resource Found',
      allowSearchFilter: true,
      clearSearchFilter: true,
      maxHeight: 200,
      // itemsShowLimit: 3,
      searchPlaceholderText: 'Search Other Resource',
      closeDropDownOnSelection: false,
    };

    // // Custom validator for customerPhone
    // const customerPhoneValidator = (control: AbstractControl) => {
    //   const value = control.value;
    //   // If value is empty, valid
    //   if (!value) return null;
    //   // Remove all non-digit characters
    //   const digitsOnly = value.replace(/\D/g, '');
    //   // Must be all digits and match brandDefaultsPhoneDigits exactly
    //   if (/^\d+$/.test(digitsOnly)) {
    //     return digitsOnly.length === this.brandDefaultsPhoneDigits ? null : { phoneDigits: true };
    //   }
    //   // If contains any non-digit, invalid
    //   return { phoneDigits: true };
    // };

    // Set allocate to false when any ResourceAssigned has resourceID 0, otherwise true if there are assigned resources
    const hasResourceIDZero = this.currentEventData?.ResourceAssigned?.some((r) => r.ResourceID === 0);
    const initialAllocate = hasResourceIDZero ? false : this.currentEventData?.ResourceAssigned?.length > 0 || this.allocated;
    this.orderDetailCardForm = new UntypedFormGroup({
      orderNumber: new UntypedFormControl(this.currentEventData?.OrderNumber),
      customer: new UntypedFormControl(this.currentEventData?.CustomerName),
      technicianResource: new UntypedFormControl(this.selectedResourceList),
      otherResource: new UntypedFormControl(this.selectedOtherResourceList),
      customerPhone: new UntypedFormControl(this.currentEventData?.CustomerPhone, [Validators.required]),
      jobTypeCode: new UntypedFormControl(this.currentEventData?.JobTypeCode, Validators.required),
      jobDescription: new UntypedFormControl(this.currentEventData?.Description, Validators.required),
      jobOwner: new UntypedFormControl(this.currentEventData?.JobOwner, Validators.required),
      allocate: new UntypedFormControl(initialAllocate),
      fitDate: new UntypedFormControl({ value: this.currentEventData?.WorkshopStartDate, disabled: initialAllocate }, Validators.required),
    });
    this.orderDetailCardForm.valueChanges.pipe(distinctUntilChanged()).subscribe(() => {
      this.isFormValid = true;
    });
    this.orderDetailCardForm
      .get('technicianResource')
      .valueChanges.pipe(distinctUntilChanged())
      .subscribe(() => {
        const val = this.orderDetailCardForm.getRawValue();
        if (((val.technicianResource || val.otherResource) && val.technicianResource?.length > 0) || val.otherResource?.length > 0) {
          this.orderDetailCardForm?.get('allocate')?.setValue(true);
          this.orderDetailCardForm.patchValue({
            fitDate: this.currentDate,
          });
        } else {
          this.orderDetailCardForm?.get('allocate')?.setValue(false);
        }
      });
    this.orderDetailCardForm
      .get('otherResource')
      .valueChanges.pipe(distinctUntilChanged())
      .subscribe(() => {
        const val = this.orderDetailCardForm.getRawValue();
        if (val.technicianResource?.length > 0 || val.otherResource?.length > 0) {
          this.orderDetailCardForm.get('allocate')?.setValue(true);
        } else {
          this.orderDetailCardForm.get('allocate')?.setValue(false);
        }
      });

    // Enable/disable fitDate when allocate changes — set disabled at creation to avoid changed-after-checked
    this.orderDetailCardForm
      .get('allocate')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unSubscribe$))
      .subscribe((val) => {
        const fitDateCtrl = this.orderDetailCardForm.get('fitDate');
        if (!fitDateCtrl) return;
        if (val) {
          fitDateCtrl.disable({ emitEvent: false });
        } else {
          fitDateCtrl.enable({ emitEvent: false });
        }
      });
  }

  resetResources() {
    this.orderDetailCardForm.get('allocate')?.setValue(false);
    this.orderDetailCardForm.get('technicianResource').setValue([]);
    this.orderDetailCardForm.get('otherResource').setValue([]);
  }

  submitOrderDetailCardForm(submit) {
    if (submit) {
      this.activeModal.close(this.orderDetailCardForm?.getRawValue());
    }
  }

  getPreAssignedResource() {
    this.currentEventData?.map((el) => {
      return { resourceID: el.ResourceID, resourceName: el.ResourceName };
    });
  }

  showNoteView() {
    this.loading.next(true);
    this.eventService
      .fetchOrderDetailsForScheduler({ jobID: this.currentEventData?.JobID })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        this.loading.next(false);
        this.allAttachments = data?.headerAttachmentArray;
        this.orderLines = data?.orderLines;
        this.notesCardView = true;
        this.actionOrderDetailCard = false;
      });
  }

  openAddEditNoteView() {
    this.notesCardView = false;
    this.actionOrderDetailCard = false;
    this.loading.next(true);
    this.entityId = `${this.currentEventData.OrderNumber.toString()}|${this.currentEventData.OrderType}|${this.defaultCompanyCode}`;
    this.entityType = 'order';
    this.orderDetails = this.currentEventData;

    this.apiService
      .loadAttachmentForOrder({
        orderNumber: this.currentEventData.OrderNumber,
        orderType: this.currentEventData.OrderType,
        JDEOrderType: this.currentEventData?.JdeOrderType,
        JDECompany: this.currentEventData?.JdeCompany,
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((res: any) => {
        this.loading.next(false);
        this.allAttachments = res?.attachmentIDArray;
        this.addEditNoteView = true;
      });
  }
  handleCloseModal(event) {
    if (event) {
      this.notesCardView = false;
      this.actionOrderDetailCard = false;
      this.activeModal.close();
    }
  }

  handleCloseNoteModal(event) {
    if (event) {
      this.notesCardView = false;
      this.scheduleHistoryView = false;
      this.actionOrderDetailCard = true;
    }
  }

  viewScheduleHistory() {
    this.loading.next(true);
    this.eventService
      .fetchOrderLedger({ jobID: this.currentEventData?.JobID })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        this.loading.next(false);
        this.ledgerResultArray = data?.ledgerArray;
        this.notesCardView = false;
        this.actionOrderDetailCard = false;
        this.scheduleHistoryView = true;
      });
  }
  showMoreDetails(index) {
    if (this.viewDetailIndex === index) {
      this.viewDetailIndex = -1;
    } else {
      this.viewDetailIndex = index;
    }
  }
  checkViewStatus(index) {
    return index === this.viewDetailIndex;
  }

  showDetails = (d: NgbDateStruct) => {
    let date: any;
    let month: any;
    if (d.day?.toString().length < 2) {
      date = '0' + d.day.toString();
    } else {
      date = d.day.toString();
    }
    if (d.month.toString().length < 2) {
      month = '0' + d.month.toString();
    } else {
      month = d.month.toString();
    }
    const selectedDay = date + '/' + month + '/' + d.year.toString();
    if (this.dayDetails.some((el) => el.date === selectedDay)) {
      setTimeout(() => {
        this.orderDetailCardForm.patchValue({
          fitDate: selectedDay.toString(),
        });
      }, 100);

      this.d2.close();
    } else {
      this.orderDetailCardForm.patchValue({
        fitDate: this.previousDateForCalander,
      });
    }
  };

  streamOpened(event) {
    this.previousDateForCalander = this.orderDetailCardForm.get('fitDate').value;

    document.querySelectorAll('.ngb-dp-month').forEach((el) => {
      el.className = 'ngb-dp-month-custom';
    });
    document.querySelectorAll('.ngb-dp-weekdays').forEach((el) => {
      el.className = 'ngb-dp-week ngb-dp-weekdays ng-star-inserted ngb-dp-weekdays-custom';
    });
    document.querySelectorAll('.ngb-dp-week').forEach((el, i) => {
      if (i === 0) {
        el.className = 'ngb-dp-week ng-star-inserted ngb-dp-week-label-custom';
      } else {
        el.className = 'ngb-dp-week ng-star-inserted ngb-dp-week-custom';
      }
    });
    document.querySelectorAll('.ngb-dp-day.ng-star-inserted').forEach((el) => {
      el.className = 'ngb-dp-day ng-star-inserted ngb-dp-day-custom';
    });
    let x = document.querySelectorAll('.ngb-dp-day');
    if (this.dateToString(x[0]?.getAttribute('aria-label')) && this.dateToString(x[x.length - 1]?.getAttribute('aria-label'))) {
      this.fetchMonthlyViewForOrder(
        this.dateToString(x[0]?.getAttribute('aria-label')),
        this.dateToString(x[x.length - 1]?.getAttribute('aria-label')),
      );
    }
  }
  navigateCalendar(event) {
    this.currentMonth = event.next.month;

    let x = document.querySelectorAll('.ngb-dp-day');
    setTimeout(() => {
      if (x[0]?.getAttribute('aria-label') && x[x.length - 1]?.getAttribute('aria-label')) {
        this.fetchMonthlyViewForOrder(
          this.dateToString(x[0]?.getAttribute('aria-label')),
          this.dateToString(x[x.length - 1]?.getAttribute('aria-label')),
        );
      }
    }, 100);
  }
  fetchMonthlyViewForOrder(startDate, endDate) {
    this.apiService
      .fetchMonthlyViewForOrder({
        startDate: startDate,
        endDate: endDate,
        orderNumber: this.currentEventData?.OrderNumber,
        branch: this.defaultBranch,
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((res: any) => {
        if (res) {
          this.dayDetails = res?.dates;
          this.fitDays = res?.fitDays;
          this.fitHours = res?.fitHours;
          setTimeout(() => {
            this.displayMonth(res?.dates, res?.fitDays, res?.fitHours);
          }, 100);
        }
      });
  }
  displayMonth(dates, fitDays, fitHours) {
    //remove latest custom Header on calendar
    if (document.querySelectorAll('.ngb-dp-week-label-custom-header').length > 0) {
      const elements = document.querySelectorAll('.ngb-dp-week-label-custom-header');
      elements.forEach((element) => {
        element.remove();
      });
    }

    let x = document?.querySelectorAll('.ngb-dp-day');
    x?.forEach((y) => {
      if (y.getAttribute('aria-label')) {
        const dateSearch = this.dateToString(y.getAttribute('aria-label'));
        if (Number(dateSearch.split('/')[1]) === this.currentMonth) {
          const data = dates.find((f) => f.date === dateSearch);
          if (data) {
            if (data?.ATPErrorTF) {
              document.getElementById(y.children[0].children[0].id).className = 'atpErrorTFCss';
            } else if (data?.fullyBookedTF) {
              document.getElementById(y.children[0].children[0].id).className = 'fullyBookedTFCss';
            } else if (data?.partialSpaceTF) {
              document.getElementById(y.children[0].children[0].id).className = 'partialSpaceTFCss';
            } else if (data?.spaceAvailable) {
              document.getElementById(y.children[0].children[0].id).className = 'spaceAvailableCss';
            }
            document.getElementById(y.children[0].children[1].id).innerHTML =
              (data.totalHoursAvail - data?.bookedHours).toFixed(2).toString() + ' hrs';
            document
              .getElementById(y.children[0].children[0].id)
              .setAttribute('title', `Booked Hrs: ${data?.bookedHours}\nBooked: ${data?.bookedPerc}%`);
          } else {
            document.getElementById(y.children[0].children[1].id).innerHTML = '';
            y.classList.add('customCss');
            document.getElementById(y.children[0].children[0].id).className = 'disabled';
          }
        }
      }
    });
  }

  isDisabled = (date: NgbDateStruct, current: { month: number; year: number }) => {
    return current.month !== date.month;
  };
  dateToString(date: any) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [day, month, year].join('/');
  }
  getToday() {
    return moment(new Date(), 'dd/mm/yyyy');
  }

  loadAllAttachmentsForEdit(attachments: any) {
    this.madeChanges = true;
    this.allAttachments = attachments;
  }

  handleCloseAttachmentModelForEdit(event) {
    if (this.madeChanges) {
      this.loading.next(true);
      this.apiService
        .saveAttachmentForOrder({
          orderNumber: this.currentEventData.OrderNumber,
          orderType: this.currentEventData.OrderType,
          JDEOrderType: this.currentEventData.JdeOrderType,
          JDECompany: this.currentEventData.JdeCompany,
        })
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((res: any) => {
          this.loading.next(false);
          //this.allAttachments = res?.attachmentIDArray;
          this.madeChanges = false;
          this.notesCardView = true;
          this.scheduleHistoryView = false;
          this.addEditNoteView = false;
          this.actionOrderDetailCard = false;
          this.showNoteView();
        });
    } else {
      this.loading.next(true);
      this.apiService
        .unloadAttachmentForOrder({
          orderNumber: this.currentEventData.OrderNumber,
          orderType: this.currentEventData.OrderType,
        })
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((res: any) => {
          this.loading.next(false);
          // this.allAttachments = res?.attachmentIDArray;
          this.notesCardView = true;
          this.scheduleHistoryView = false;
          this.addEditNoteView = false;
          this.actionOrderDetailCard = false;
          this.showNoteView();
        });
    }
  }
}

